import { styled } from '@mui/styles';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import InfoIcon from '@mui/icons-material/HelpOutlineOutlined';
import React from 'react';

export const BootstrapTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme, tooltipStyle, arrowStyle }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: 'transparent',
    ...arrowStyle
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.neutral['clr-800'],
    color: theme.palette.shades['clr-white-900'],
    boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
    padding: 10,
    maxWidth: 300,
    ...theme.typography['body01-bold'],
    ...tooltipStyle
  },
}));

function InfoTooltip({ title = '', placement = 'bottom', ...props }) {
  return (
    <BootstrapTooltip title={title} placement={placement} {...props}>
      <InfoIcon
        sx={{
          fontSize: 12,
          cursor: 'pointer',
        }}
      />
    </BootstrapTooltip>
  );
}

export const CustomTooltip = ({
  component, placement = 'top', children, tooltipStyle={}, arrowStyle={}, show=false,
  ...props
}) => {
  const [open, setOpen] = React.useState(false);

  React.useEffect(() => {
    setOpen(show);
  }, [show]);

  return (
    <BootstrapTooltip 
      title={component || ''}
      placement={placement}
      tooltipStyle={tooltipStyle}
      arrowStyle={arrowStyle}
      open={open}
      onOpen={() => setOpen(true)}
      onClose={() => setOpen(false)}
      {...props}
    >
      {children}
    </BootstrapTooltip>
  )
}

export default InfoTooltip;